import React from 'react';
import { Box, useTheme } from '@mui/material';

export default function OrbitLogo({ height = 36, sx = {} }) {
  const theme = useTheme();
  const src = theme.palette.mode === 'dark'
    ? '/images/logos/orbit-on-dark.svg'
    : '/images/logos/orbit-on-white.svg';

  return (
    <Box
      component="img"
      src={src}
      alt="Orbit"
      sx={{ height, width: 'auto', display: 'block', ...sx }}
    />
  );
}
